import {authRoutes} from './auth';
import {managerRoutes} from './manager';
import {adminRoutes} from './admin';

export const publicRoutes = [...authRoutes];
export const privateRoutes = [...adminRoutes, ...managerRoutes];
